"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textTruncate = exports.numberNth = exports.isDev = exports.handleFormChange = exports.getSlug = exports.getBaseUrl = exports.generateKey = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _envConstants = require("../../env-constants");
var isDev = exports.isDev = _envConstants.ENV.NODE_ENV === 'development';
var generateKey = exports.generateKey = function generateKey() {
  var pre = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'key';
  return "".concat(pre, "_").concat(new Date().getTime());
};
var getBaseUrl = exports.getBaseUrl = function getBaseUrl(config) {
  return config.apiUrl;
};
var getSlug = exports.getSlug = function getSlug(post) {
  var year = post.date.substr(0, 4);
  var month = post.date.substr(5, 2);
  return "/blog/".concat(year, "/").concat(month, "/").concat(post.slug);
};
var handleFormChange = exports.handleFormChange = function handleFormChange(component, e) {
  var _e$target = e.target,
    name = _e$target.name,
    type = _e$target.type,
    value = _e$target.value;
  var val = type === 'number' ? parseFloat(value) : value;
  component.setState((0, _defineProperty2["default"])({}, name, val));
};
var numberNth = exports.numberNth = function numberNth(d) {
  if (d > 3 && d < 21) return "".concat(d, "th");
  switch (d % 10) {
    case 1:
      return "".concat(d, "st");
    case 2:
      return "".concat(d, "nd");
    case 3:
      return "".concat(d, "rd");
    default:
      return "".concat(d, "th");
  }
};
var textTruncate = exports.textTruncate = function textTruncate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var ending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  if (str === null) {
    return;
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }
  return str;
};